export enum TocDisplayStyle {
  CLASSIC = 'Classic',
  SMOOTHSCROLL = 'SmoothScroll',
}
